import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyC0KQ7O71pKjJabZu0Q4uoaWbA7ygz_6Xs",
  authDomain: "dnd-chatbot-3258c.firebaseapp.com",
  projectId: "dnd-chatbot-3258c",
  storageBucket: "dnd-chatbot-3258c.firebasestorage.app",
  messagingSenderId: "959992896057",
  appId: "1:959992896057:web:d3c51d8912fa9f2d304be8",
  measurementId: "G-9QE54ERGDJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
